import { gql } from '@apollo/client';
export const query = gql `
  query CategoriesForMetadata {
    categories: categories2 {
      id
      metadata {
        id
        title
        marketLocaleCode
      }
    }
  }
`;
